import moment from "moment";
import {parsePhoneNumberFromString, isValidNumber} from "libphonenumber-js";

export const getCurrentUser = () => {
  let user = null;
  try {
    user = localStorage.getItem("user") != null ? JSON.parse(localStorage.getItem("user")) : null;
  } catch (error) {
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  } catch (error) {}
};

export const formatPhoneNumber = (value, index) => {
  value = value.replaceAll(/\s/g, "");
  if (value.length === 0) {
    this.validNumbers[index].valid = true;
    return;
  }
  let phoneNumber = parsePhoneNumberFromString(value, "TN");
  if (value) {
    if (!phoneNumber) {
      this.validNumbers[index].valid = true;
      return;
    }
    this.validNumbers[index].valid = isValidNumber(phoneNumber.number);
    if (phoneNumber && this.validNumbers[index].valid) {
      if (index === 2) {
        this.isUniquet(phoneNumber.formatNational());
        this.student.parents_tuteur[0].phone = phoneNumber.formatNational();
      } else {
        if (index === 0) {
          this.isUniquep(phoneNumber.formatNational());
        } else {
          if (index === 3) this.student.phone_number = phoneNumber.formatNational();
          else this.isUniquem(phoneNumber.formatNational());
        }
      }
    } else if (phoneNumber.length > 2) {
      if (index === 2) this.student.parents_tuteur[0].phone = value;
      else this.student.parents[index].phone = value;
    }
  }
};

export const isValidPhoneNumber = (phoneNumber, countryCode) => {
  const phoneRegex = {
    TN: /^(?:\+216|216)?(\d{8})$/,
  };

  const normalizedNumber = phoneNumber.replace(/[\s\-()]/g, "");

  const match = phoneRegex[countryCode].exec(normalizedNumber);

  if (match) {
    const localNumber = match[1];

    const formattedNumber = localNumber.replace(/(\d{2})(\d{3})(\d{3})/, "$1 $2 $3");

    return formattedNumber;
  } else {
    return false;
  }
};
export const formatDate = (value) => {
  if (value) {
    return moment(String(value)).utc().format("DD-MM-YYYY");
  }
};

export const maxDate = () => {
  return moment().utc().format("YYYY-MM-DD");
};
